import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-8`;
const Grid = tw.div`
  grid
  grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5
  gap-6
  mx-4
`;

const Card = styled.a`
  ${tw`
    flex! flex-col h-full w-full 
    sm:border sm:rounded-tl-4xl sm:rounded-br-5xl 
    relative focus:outline-none
    bg-primary-200 text-black
    cursor-pointer
    transition duration-300
    hover:bg-primary-300
    hover:scale-105
  `}
`;

const CardImage = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-40 sm:h-48 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`,
]);

const TextInfo = tw.div`p-4`;
const Title = tw.h5`text-lg font-bold`;

export default function RoutingItems({ cards }) {
  if (!cards || cards.length === 0) return null;

  return (
    <Container>
      <Content>
        <Grid>
          {cards.map((card, index) => (
            <Card key={index} href={card.link} target={card.openInNewWindow ? "_blank" : "_parent"}>
              <CardImage imageSrc={card.imageSrc} />
              <TextInfo>
                <Title>{card.title}</Title>
              </TextInfo>
            </Card>
          ))}
        </Grid>
      </Content>
    </Container>
  );
}
